module.exports = __webpack_public_path__ + "img/alba-vignette.79e5756b.jpg";